import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import { isTokenExpired } from '@/services/auth';

const routes: Array<RouteRecordRaw> = [
  {
    name: 'Library',
    path: '/',
    component: () => import('@/views/Library.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'Shared',
    path: '/shared',
    component: () => import('@/views/Share.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'SongDetail',
    path: '/song/:id',
    component: () => import('@/views/Song.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'ShareControl',
    path: '/song/:id/settings',
    component: () => import('@/views/ShareControl.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'PlaylistDetail',
    path: '/playlist/:id',
    component: () => import('@/views/Playlist.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/Login.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'Get Started',
    path: '/get-started',
    component: () => import('@/views/Login.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'Sign In',
    path: '/sign-in',
    component: () => import('@/views/Login.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'Sign Up',
    path: '/sign-up',
    component: () => import('@/views/Login.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'Logout',
    path: '/logout',
    component: () => import('@/views/Logout.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'Share',
    path: '/share/:id',
    component: () => import('@/views/Share.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'Install',
    path: '/install',
    component: () => import('@/views/Install.vue'),
    meta: {
      guest: true,
    },
  },
  {
    name: 'PaymentSuccess',
    path: '/payment-success',
    component: () => import('@/views/PaymentSuccess.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'Onboarding',
    path: '/onboarding',
    component: () => import('@/views/OnBoarding.vue'),
    meta: {
      guest: false,
    },
  },
  {
    name: 'CatchAll',
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('crate.auth.access_token') || '';
  const user = JSON.parse(localStorage.getItem('crate.auth.user') || '{}');

  if (
    !user.email &&
    (!token || isTokenExpired(token)) &&
    !to.meta.guest &&
    to.name !== 'Login' &&
    to.name !== 'Install'
  ) {
    return next({ name: 'Login' });
  }

  next();
});

export default router;
